import { Alert, Badge, Spinner } from 'reactstrap';

/**
 * #116 — Einheitlicher API-Status-Streifen fuer die Produkt-Seiten.
 *
 * Nimmt ein react-query-Ergebnis (typischerweise die /healthz-Abfrage) und
 * rendert konsistent Laden/erreichbar/nicht erreichbar. Zusatz-Badges (z. B.
 * Monitoring-Status) als children. Ersetzt den pro Seite kopierten Alert
 * (~9 Stellen).
 *
 * @param {object} p
 * @param {{ isLoading?: boolean, isError?: boolean }} p.health  react-query-Result.
 */
export function ApiHealthStrip({ health, children }) {
  return (
    <Alert color={health?.isError ? 'danger' : 'light'} className="d-flex align-items-center gap-2 small">
      <strong>API-Status:</strong>
      {health?.isLoading ? <><Spinner size="sm" /> prüfe …</>
        : health?.isError ? <Badge color="danger" pill>nicht erreichbar</Badge>
        : <Badge color="success" pill>erreichbar</Badge>}
      {children}
    </Alert>
  );
}
